import daysPlural from '@/utils/daysPlural';
import {
    getStatusText as getStatusTextFallback,
    getStatusVariant as getStatusVariantFallback,
    isFinalStatus
} from '@/utils/requestStatuses';

export function getRequestBadges(request, moment, options = {}) {
    if (!request || !moment) {
        return [];
    }

    const badges = [{
        key: 'status',
        variant: request.status_variant || getStatusVariantFallback(request.status),
        text: request.status_label || getStatusTextFallback(request.status),
        decision: request.status_decision || null
    }];

    const finalStatus = isFinalStatus(request.status);

    if (options.isNew && !finalStatus) {
        badges.push({
            key: 'new',
            variant: 'success',
            text: 'Новая'
        });
    }

    if (request.deadline && !finalStatus) {
        if (moment(request.deadline).isSame(moment(), 'day')) {
            badges.push({
                key: 'deadline-today',
                variant: 'info',
                text: 'Сегодня'
            });
        } else if (moment().isAfter(request.deadline)) {
            const overdueDays = Math.floor(moment().diff(moment(request.deadline)) / (1000 * 60 * 60 * 24));
            badges.push({
                key: 'deadline-overdue',
                variant: 'danger',
                html: `<b>Просрочена:</b> ${overdueDays} ${daysPlural(overdueDays)}`
            });
        } else if (moment().isBefore(request.deadline)) {
            const remainingDays = Math.floor(moment(request.deadline).diff(moment()) / (1000 * 60 * 60 * 24));
            badges.push({
                key: 'deadline-remaining',
                variant: 'warning',
                text: `Осталось ${remainingDays} ${daysPlural(remainingDays)}`
            });
        }
    }

    if (request.priority === 'urgent') {
        badges.push({
            key: 'priority-urgent',
            variant: 'danger',
            text: 'Срочно'
        });
    } else if (request.priority === 'high') {
        badges.push({
            key: 'priority-high',
            variant: 'warning',
            text: 'Высокий приоритет'
        });
    }

    return badges;
}

export default getRequestBadges;
